<script>
import {required, numeric} from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import vue2Dropzone from 'vue2-dropzone';
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Multiselect from "vue-multiselect";

export default {
  components: {validationMessages, vueDropzone: vue2Dropzone, Multiselect},

  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      productName: '',
      // productDescription: [{item: ""}],
      productDescription: "",
      productPriceTypes:[],
      productBrand: '',
      productPrice: [],
      productClubPrice: '',
      productPromoPrice: '',
      productQuantity: '',
      productWarranty: '',
      productImage: null,
      productCategory: '',
      categoriesData: [],
      formatedCategories: [],
      merchandiseBrand: [],
      selectedPriceType:"",
      dropzoneOptions: {
        url: '#',
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 1,
        acceptedFiles: '.jpg,.jpeg,.png,.gif,.bmp,.webp',
        addRemoveLinks: true,
        dictDefaultMessage: 'Drop image file here or click to upload.',
        dictRemoveFile: 'Remove',
        dictCancelUpload: 'Cancel',
        dictUploadCanceled: 'Upload canceled.',
        dictInvalidFileType: 'Invalid file type. Only images are allowed.',
        dictFileTooBig: 'File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.',
        dictMaxFilesExceeded: 'You can not upload any more files.',
      }
    };
  },

  validations: {
    productName: {required},
    productDescription: {required},
    productBrand: {required},
    productCategory: {required},
    productPrice: {required},
    productImage: {required},
  },

  methods: {
    selectFileProductImage(files) {
      if (files.length > 0) {
        this.productImage = files[0];
      }
    },
    addProductDescriptionItem() {
      this.productDescription.push({item: ""});
    },
    handlePriceTypeSelect() {
      if(!this.selectedPriceType) return;
      if (!Array.isArray(this.productPrice)) {
        this.productPrice = [];
      }
      const exists = this.productPrice.some((p)=> p.product_price_type_id === this.selectedPriceType.type_id);
      if(exists === false) {
        this.productPrice.push({
          product_price_type_id: this.selectedPriceType.type_id,
          type_name: this.selectedPriceType.type_name,
          price:"",
        })
      }

      this.selectedPriceType = "";

    },
    removeProductDescriptionItem(index) {
      if (this.productDescription.length === 1) return;
      this.productDescription.splice(index, 1);
    },
    removeProductPriceItem(typeId) {
      this.productPrice = this.productPrice.filter(
      (item) => item.product_price_type_id !== typeId
  );
    },
    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      // const prodDescriptionArr = this.productDescription.map(item => item.item);
      // const prodDescriptionArrStr = prodDescriptionArr.join('\r\n');


      // const prodDescriptionArrStr = this.productDescription.join('\r\n');



      this.showLoader = true;
      let formData = new FormData();
      formData.append("name", this.productName);
      // formData.append("description", JSON.stringify(this.productDescription.map(item => item.item)));
      // formData.append("description", prodDescriptionArrStr);
      formData.append("description", this.productDescription);
      formData.append("brand", this.productBrand.brand_name);
      formData.append("category", this.productCategory.id);
      formData.append("source", "Riversoft");
      formData.append("prices",   JSON.stringify(
          (this.productPrice || []).map(p => ({
            product_price_type_id: p.product_price_type_id ?? p.product_price_type_id, // handles both keys
            price: p.price
          }))))
      // formData.append("clubPrice", this.productClubPrice);
      // formData.append("promoPrice", this.productPromoPrice);
      formData.append("image", this.productImage);
      formData.append("warranty", this.productWarranty);
      formData.append("quantity", this.productQuantity);


      try {
        const response = await Merchandising.createProduct(formData);
        if (response.data.success === false) {
          Swal.fire("Error", response.data.error || "Failed to create product. Please try again.", "error");
        } else {
          Swal.fire("Success", "Product successfully created!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create product:", error);
        Swal.fire("Error", error.response?.data?.errors || "Failed to create product. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
      this.$v.$reset();
      this.productName = '';
      // this.productDescription = [{item: ""}];
      this.productDescription = "";
      this.productBrand = '';
      this.productPrice = [];
      this.productClubPrice = '';
      this.productPromoPrice = '';
      this.productQuantity = '';
      this.productWarranty = '';
      this.productImage = null;
      this.productCategory = '';
      this.categoriesData = [];
      this.formatedCategories = [];
      this.merchandiseBrand = [];
      this.selectedPriceType = "";
      this.productPriceTypes = [];


    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },
    flattenCategories(categories) {
      const result = []

      Object.values(categories).forEach(cat => {
        // main category
        result.push({id: cat.ID_Grupa, name: cat.name})

        if (cat.subcategories) {
          Object.values(cat.subcategories).forEach(sub => {
            // sub category
            result.push({id: sub.ID_PodGrupa, name: sub.name})

            if (sub.subsubcategories) {
              Object.values(sub.subsubcategories).forEach(subsub => {
                result.push({id: subsub.category_id, name: subsub.category_name})
              })
            }
          })
        }
      })

      return result
    },
    async getBrands() {
      this.toggleBusy();
      try {
        const {data} = await Merchandising.getMerchandiseBrand();
        this.merchandiseBrand = data.data.data || [];
      } catch (error) {
        this.error = error?.response?.data?.error || "An unexpected error occurred.";
        console.error(error);
      } finally {
        this.toggleBusy();
      }
    },
    async getProductPriceTypes() {
      this.toggleBusy();
      try {
        const response = await Merchandising.getProductPriceTypes();
        this.productPriceTypes = response.data.data || [];
       this.productPriceTypes = this.productPriceTypes.filter(item => item.type_name !== 'discount');
      } catch (error) {
        this.error = error?.response?.data?.error || "An unexpected error occurred.";
        console.error(error);
      } finally {
        this.toggleBusy();
      }
    },
    async getCategories() {
      try {
        const response = await Merchandising.getCategories();
        this.categoriesData = response.data.data;
        this.formatedCategories = this.flattenCategories(this.categoriesData);
      } catch (error) {
        console.log(error);
      }
    },


    refreshData() {
      this.$emit("onRefresh");
    },
    async syncData() {
      await this.getBrands();
      await this.getCategories();
      await this.getProductPriceTypes();
    }
  },
};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="add_product"
      size="xl"
      v-model="showModal"
      title="Add Product"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="$v.$error" class="text-danger">Complete all fields</div>
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <div class="row">
              <div class="col-6">
                <b-form-group label="Product Name" class="mb-3">
                  <b-form-input
                      v-model.trim="productName"
                      :class="{ 'is-invalid': submitted && $v.productName.$error }"
                  ></b-form-input>
                  <validationMessages
                      v-if="submitted"
                      :fieldName="'Product Name'"
                      :validationName="$v.productName"
                  ></validationMessages>
                </b-form-group>
<!--                <div>-->
<!--                  <div class="d-flex align-items-center justify-content-between">-->
<!--                    <label class="form-label">-->
<!--                      <span>Product Description</span>-->
<!--                    </label>-->
<!--                    <b-button size="sm" class="w-20" style="position: relative; bottom: 5px" variant="outline-primary"-->
<!--                              @click.prevent="addProductDescriptionItem">+ Add Description Item-->
<!--                    </b-button>-->
<!--                  </div>-->
<!--                  <div v-for="(item, index) in productDescription" :key="index" class="mb-3 border rounded-3">-->
<!--                    <div class="d-flex align-items-start gap-2">-->
<!--                      <b-form-input-->
<!--                          v-model.trim="item.item"-->
<!--                          type="text"-->
<!--                          :id="'item-' + index"-->
<!--                      >-->
<!--                      </b-form-input>-->
<!--                      <b-button-->
<!--                          v-if="productDescription.length > 1"-->
<!--                          variant="outline-danger"-->
<!--                          class="ms-2"-->
<!--                          @click.prevent="removeProductDescriptionItem(index)"-->
<!--                          title="Remove this description item">-->
<!--                        <i class="uil uil-trash-alt"></i>-->
<!--                      </b-button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                            <b-form-group label="Product Description" class="mb-3">
                                 <textarea class="form-control"
                                     v-model.trim="productDescription"
                                     :class="{ 'is-invalid': submitted && $v.productDescription.$error }"
                                 />
                                 <validationMessages
                                     v-if="submitted"
                                     :fieldName="'Product Description'"
                                     :validationName="$v.productDescription"
                                 ></validationMessages>
                               </b-form-group>
                <b-form-group label="Product Brand" class="mb-3">
                  <multiselect v-model="productBrand"
                               label="brand_name"
                               track-by="brand_id"
                               placeholder="Type to search brands"
                               :multiple="false"
                               :options="merchandiseBrand"
                               :searchable="true"
                               :loading="showLoader"
                               :internal-search="true"
                               :clear-on-select="false"
                               :close-on-select="true"
                               :options-limit="300"
                               :max-height="600"
                               :show-no-results="false"
                               :hide-selected="true"
                               :class="{ 'is-invalid': submitted && $v.productBrand.$error }">
                    <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                        <span>{{ option.name }}</span>
                        <span class="custom__remove" @click="remove(option)">✖</span>
                    </span>
                    </template>
                  </multiselect>
                  <validationMessages
                      v-if="submitted"
                      :fieldName="'Product Brand'"
                      :validationName="$v.productBrand"
                  ></validationMessages>
                </b-form-group>
                <b-form-group label="Product Category" class="mb-3">
                  <multiselect v-model="productCategory"
                               label="name"
                               track-by="id"
                               placeholder="Type to search categories"
                               :multiple="false"
                               :options="formatedCategories"
                               :searchable="true"
                               :loading="showLoader"
                               :internal-search="true"
                               :clear-on-select="false"
                               :close-on-select="true"
                               :options-limit="300"
                               :max-height="600"
                               :show-no-results="false"
                               :hide-selected="true"
                               :class="{ 'is-invalid': submitted && $v.productCategory.$error }">
                    <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                        <span>{{ option.name }}</span>
                        <span class="custom__remove" @click="remove(option)">✖</span>
                    </span>
                    </template>
                  </multiselect>
                  <validationMessages
                      v-if="submitted"
                      :fieldName="'Product Category'"
                      :validationName="$v.productCategory"
                  ></validationMessages>
                </b-form-group>
              </div>

              <div class="col-6">
                <div>
                  <div class="d-flex align-items-center justify-content-between">
                    <label class="form-label">
                      <span>Product Price</span>
                    </label>
                    <select v-model="selectedPriceType" @change="handlePriceTypeSelect" class="form-select w-25 mb-3">
                      <option disabled value="">Select Type</option>
                      <option v-for="priceType in productPriceTypes" :key="priceType.product_price_type_id" :value="priceType">
                        Cena_{{priceType.type_name}}
                      </option>
                    </select>

                  </div>
                  <div v-for="item in productPrice" :key="item.product_price_type_id" class="mb-3">
                    <div class="d-flex align-items-start gap-2">
                      <label class="form-label w-50 mb-0">
                        Cena_{{ item.type_name }}
                      </label>

                      <b-form-input
                          v-model.trim="item.price"
                          type="text"
                          :id="'price-' + item.type_id"
                      />

                      <b-button
                          variant="outline-danger"
                          class="ms-2"
                          @click.prevent="removeProductPriceItem(item.product_price_type_id)"
                          title="Remove this price item"
                      >
                        <i class="uil uil-trash-alt"></i>
                      </b-button>
                    </div>
                </div>
                  <validationMessages
                      v-if="submitted"
                      :fieldName="'Product Price'"
                      :validationName="$v.productPrice"
                  ></validationMessages>
                </div>
                <b-form-group label="Product Quantity" class="mb-3">
                  <b-form-input
                      v-model.trim="productQuantity"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Product Warranty" class="mb-3">
                  <b-form-input
                      v-model.trim="productWarranty"
                  ></b-form-input>
                </b-form-group>
              </div>


            </div>


            <b-form-group label="Product Image" class="mb-3">
              <vueDropzone
                  id="product_image"
                  ref="myVueDropzone_product_image"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  @vdropzone-files-added="selectFileProductImage"
                  no-progress-bar
              >
                <div class="dropzone-custom-content">
                  <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                  <h4>Drop image file here or click to upload.</h4>
                  <p class="text-muted">Max file size: 5MB</p>
                </div>
              </vueDropzone>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Product Image'"
                  :validationName="$v.productImage"
              ></validationMessages>
            </b-form-group>


            <!--            <b-form-group label="Attribute Visibility" class="mb-3">-->
            <!--              <div class=" form-check form-switch form-switch-lg">-->
            <!--                <input-->
            <!--                    type="checkbox"-->
            <!--                    class="form-check-input"-->
            <!--                    id="switch1"-->
            <!--                    :true-value="1"-->
            <!--                    :false-value="0"-->
            <!--                    v-model.trim="attrVisibility"-->
            <!--                    :class="{ 'is-invalid': submitted && $v.attrVisibility.$error }"-->
            <!--                />-->

            <!--              </div>-->

            <!--              <validationMessages-->
            <!--                  v-if="submitted"-->
            <!--                  :fieldName="'Attribute Visibility'"-->
            <!--                  :validationName="$v.attrVisibility"-->
            <!--              ></validationMessages>-->
            <!--            </b-form-group>-->


          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
